import { SectionsWrapper, SideBarWrapper } from './styles';
import SideBarInfoSection from './SideBarInfo';
import SideBarLinksSection from './SideBarLinks';
import SideBarHelpersAction from './SideBarHelpersAction';
import { useSelector } from 'react-redux';
import { getSideMenuState } from '../../store/sideMenu.slice';

export default function SideBar() {
  const isSideBarOpen = useSelector(getSideMenuState);

  return (
    <SideBarWrapper className={`${isSideBarOpen ? 'open' : 'close'}`}>
      <SectionsWrapper>
        <SideBarLinksSection />
        {/* <SideBarHelpersAction /> */}
      </SectionsWrapper>
    </SideBarWrapper>
  );
}
